import * as React from 'react'
import { PlantHalt } from '../../../../../types/plantHalts'
import duration from '../../../../../functions/duration'
import { totalsByCause } from './causes'

interface Props {
  halts: PlantHalt[]
  t: (key: string) => string
}

/**
 * Totali dei tempi di fermo suddivisi per causa, affiancati ai totali per linea.
 *
 * Riceve gli stessi fermi dei totali per linea, quindi reagisce agli stessi filtri (linea,
 * turno, cause, data). Le cause sono quelle presenti nei fermi, ordinate per durata.
 */
const CauseTotals = (props: Props) => {
  const { halts, t } = props
  const { causes, disabled, totalSeconds, totalCount } = totalsByCause(halts)

  return (
    <div className="plant-halts-cause-totals mb-3">
      <div className="font-weight-bold text-muted mb-1">{t('plantHalts.list.causeTotals')}</div>
      {causes.map(cause => (
        <div key={cause.key} className="line-total">
          <span className="font-weight-bold mr-2">{`${cause.label} [${cause.count}]:`}</span>
          <span>{duration(cause.seconds)}</span>
        </div>
      ))}
      <div className="line-total line-total-all">
        <span className="font-weight-bold mr-2">
          {`${t('plantHalts.list.allCausesTotal')} [${totalCount ? totalCount : '-'}]:`}
        </span>
        <span>{duration(totalSeconds)}</span>
      </div>
      {disabled && (
        <div className="line-total text-muted">
          <span className="mr-2">{`${disabled.label} [${disabled.count}]:`}</span>
          <span>{duration(disabled.seconds)}</span>
          <span className="ml-2 font-italic">{`· ${t('plantHalts.list.excludedFromTotal')}`}</span>
        </div>
      )}
    </div>
  )
}

export default CauseTotals
